module.exports = __webpack_public_path__ + "img/20.8ba81257.png";